import { INVENTORY_QUERY_FRAGMENT } from '../../../../common/inventory/services/InventoryService';
import { BaseGQLService } from '../../../../common/services/BaseGQLService';
import { ModelType } from '../../../../common/utils/GQLIdEncoder';
import { ReportExportOptions } from '../../../options/ReportExportOptions';
import { ReportPrintMapper } from '../mappers/ReportPrintMapper';
import { ReportPrintData } from '../models/ReportPrintData';

export const REPORT_SUMMARY_FRAGMENT = `
id
name
createdAt
completedAt
traceType
trace {
  name
}
profile {
  id
  name
  type
}
project {
  id
  name
}
nonsensitiveSalt
coverageSummary {
  total
  covered
  depth
}
`;

export const GET_REPORT_PRINT_QUERY = `
query ($reportId: ID!, $includeFilteredRules: Boolean!, $instancesKeptByFilters: Boolean) {
  report: node(id: $reportId) {
    ... on ReportDone {
      ${REPORT_SUMMARY_FRAGMENT}
      rules(includeFilteredRules: $includeFilteredRules) {
        edges {
          node {
            number
            title
            shortExplanation
            severity
          }
        }
      }
      inventory {
        ${INVENTORY_QUERY_FRAGMENT}
      }
      javaProviders {
        name
        version
        vulnerabilities {
          name
          url
        }
      }
      objectStats {
        type
        value
        count
      }
      callLimiting {
        callsLimited
        maxCallsPerBucket
        maxCallsTotal
        numCallsKept
        numCallsOverBucketLimit
        numCallsOverTotalLimit
        numCallsTotal
        numBuckets
        numFullBuckets
      }
    }
    ... on ReportDone {
      allInstances: instances {
        totalCount
      }
      highInstances: instances(keptByFilters: $instancesKeptByFilters, filters: {field: severity, value: "HIGH"}){
        totalCount
      }
      mediumInstances: instances(keptByFilters: $instancesKeptByFilters, filters: {field: severity, value: "MEDIUM"}) {
        totalCount
      }
      lowInstances: instances(keptByFilters: $instancesKeptByFilters, filters: {field: severity, value: "LOW"}) {
        totalCount
      }
      passedInstances: instances(keptByFilters: $instancesKeptByFilters, filters: {field: severity, value: "PASSED"}) {
        totalCount
      }
    }
  }
}
`;

export class ReportPrintRepository extends BaseGQLService {
  private readonly mapper = new ReportPrintMapper();

  protected addTypename(): boolean {
    return false;
  }

  async getReport(reportId: number, options: ReportExportOptions): Promise<ReportPrintData> {
    const { includeFilteredRules } = options;
    return this.query(
      GET_REPORT_PRINT_QUERY,
      {
        reportId: this.gqlIdEncoder.encode(ModelType.Report, reportId),
        includeFilteredRules,
        instancesKeptByFilters: includeFilteredRules ? null : true,
      },
      (data) => this.mapper.mapGQLModel(data.report)
    );
  }
}
